<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormProfile
      :Profile="profiles"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormProfile from '../components/FormProfile.vue';

export default {
  components: {
    FormProfile,
  },
  name: 'EditProfile',
  module: 'Profile',
  mixins: [loading],
  computed: {
    /** Vuex states
     */
    ...mapState('profiles', ['profiles']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.profileId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_profiles();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('profiles', ['LOAD_profiles', 'CREATE_profile', 'UPDATE_profile']),
    /** Method used to save the item
     */
    async save(profile) {
      this.isSaving = true;
      await this.UPDATE_profile(profile);
      this.isSaving = false;
      this.$root.$emit('toast:notify', this.$t('common.phrases.savedSuccessfully'));
      this.$router.push({ name: 'AuthHome' });
    },
  },
};
</script>

<docs>
# EditProfile example

'''js
<EditProfile :Profile="Profile" />
'''
</docs>
